// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WoO7","questions":"styles_questions__1-U0x","footer":"styles_footer__To_OR"};